import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '~/pwa/pwaInstall'; // wczesny nasłuch beforeinstallprompt (przed montażem komponentów)
import { GlobalProvider } from './context/GlobalContext';
import { BrowserRouter } from 'react-router-dom';

if (process.env.REACT_APP_VCONSOLE === 'true') {
  import('vconsole').then(({ default: VConsole }) => {
    // 1. Przypisujemy instancję do zmiennej
    const vConsole = new VConsole();
    
    // 2. Ustawiamy pozycję (x: odległość od prawej, y: odległość od dołu)
    // Przykład: przesuwa przycisk o 50 pikseli w lewo i 100 pikseli w górę
    vConsole.setSwitchPosition(30, 70); 
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  // <React.StrictMode>
    <BrowserRouter basename="/">
      <GlobalProvider>
        <App />
      </GlobalProvider>
    </BrowserRouter>
  // </React.StrictMode>,
);

reportWebVitals();